import * as React from "react";
import { useState } from "react";
import { SignUpForm } from "user-management/src/components/signUpForm";
import { ClinicOnboardView } from "./clinicOnboardView";
import { SignInLink } from "./signLinks";
import { ClinicRoute } from "../../../clinic/ClinicRoutes";
import { KAHUN_PLATFORM } from "user-management/src/components/loginForm";
import { CLINIC_MANAGE_URL } from "../clinicSettings/clinicUrls";
//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicSignupProps {
  goToSignIn: () => void;
  onSignUpComplete: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicSignup = ({ ...props }: ClinicSignupProps) => {
  const [errMsg, setErrMsg] = useState("");
  return (
    <ClinicOnboardView title={"Sign Up to Kahun"} errMsg={errMsg}>
      <SignUpForm
        customClientData={{
          verifyUrl: `https://${window.location.hostname}${CLINIC_MANAGE_URL}/${ClinicRoute.Verify}`,
        }}
        onSignUpComplete={props.onSignUpComplete}
        onError={setErrMsg}
        platform={KAHUN_PLATFORM.ClinicManage}
      >
        <SignInLink goToSignIn={props.goToSignIn} />
      </SignUpForm>
    </ClinicOnboardView>
  );
};
